import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import EventsPage from './pages/EventsPage';
import RulesetsPage from './pages/RulesetsPage';
import ListsPage from './pages/ListsPage';
import MetricsPage from './pages/MetricsPage';
import SimulatePage from './pages/SimulatePage';
import AuditPage from './pages/AuditPage';
import ProfilesPage from './pages/ProfilesPage';

function App() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const navItems = [
    { path: '/', label: 'Dashboard', icon: '📊' },
    { path: '/events', label: 'Events', icon: '📋' },
    { path: '/profiles', label: 'Profiles', icon: '👤' },
    { path: '/rulesets', label: 'Rulesets', icon: '📜' },
    { path: '/lists', label: 'Allow/Deny Lists', icon: '📝' },
    { path: '/simulate', label: 'Simulate', icon: '🧪' },
    { path: '/audit', label: 'Audit Log', icon: '📚' },
  ];

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 flex">
      {/* Sidebar */}
      <aside
        className={`${
          sidebarOpen ? 'w-64' : 'w-16'
        } bg-gray-800 border-r border-gray-700 transition-all duration-300`}
      >
        <div className="p-4 border-b border-gray-700 flex items-center justify-between">
          {sidebarOpen && (
            <h1 className="text-xl font-bold text-blue-400">FraudGuard</h1>
          )}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-2 rounded hover:bg-gray-700"
          >
            {sidebarOpen ? '◀' : '▶'}
          </button>
        </div>
        <nav className="p-2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-3 py-2 rounded-lg mb-1 transition-colors ${
                location.pathname === item.path
                  ? 'bg-blue-600 text-white'
                  : 'hover:bg-gray-700 text-gray-300'
              }`}
            >
              <span>{item.icon}</span>
              {sidebarOpen && <span>{item.label}</span>}
            </Link>
          ))}
        </nav>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Routes>
          <Route path="/" element={<MetricsPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/profiles" element={<ProfilesPage />} />
          <Route path="/rulesets" element={<RulesetsPage />} />
          <Route path="/lists" element={<ListsPage />} />
          <Route path="/simulate" element={<SimulatePage />} />
          <Route path="/audit" element={<AuditPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
